//----------------------------------------------------
//     general mouse/keyboard accessibility fix
//----------------------------------------------------
$(document).on( 'mousedown touchdown', 'a, button, input, select, input[type=radio] + label, input[type=checkbox] + label, label, .button, textarea', function(e) {
    $(this).addClass('no-focus');
}).on('blur touchend', function(e) {
    $(this).removeClass('no-focus');
});

if ( $(window).width() < 768) {
    $('.main-nav').hide();

    $('.mobile-nav-toggle').on('click', function() {
        $(this).toggleClass('active');
        $('.main-nav').slideToggle(250);
    });
}

$(window).load(function() {
    $('.darth-phader').darthphader({
        'animationDuration' : 1000,
        'waitTime' : 4000,
        'autoPhader' : true,
        'crossfade' : true,
        'slide' : '.slide',
        'container' : '.slide-contain',
        'accessible' : true,
        'showNav' : false
    });
});
